import { jsxs as s, jsx as e } from "react/jsx-runtime";
import R from "classnames";
import { forwardRef as U, useState as w, cloneElement as B } from "react";
import t from "./index.es678.js";
import { NotificationIndicator as P } from "./index.es93.js";
import { BodyText as N } from "./index.es487.js";
import { UtilityChevronIcon as S } from "./index.es422.js";
const W = (o, n) => o && n ? `filter-${o}${n}` : o ? `filter-${o}` : n ? `filter-${n}` : "empty-filter", b = "filter-tagged-button-component", j = 18, H = 16, g = 20, X = U(
  ({
    categoryText: o,
    Icon: n,
    paddingSize: l = 8,
    disabled: r,
    size: $ = "default",
    tagValue: a,
    onClick: i,
    isInsidePanel: T,
    testId: _ = b,
    width: c,
    maxWidth: d,
    open: m = !1,
    isReadOnly: f,
    hasNotification: O,
    ...D
  }, E) => {
    const [v, x] = w(m), y = {
      "--padding-size": `${l}px`,
      "--max-width": `${d}px`,
      "--width": `${c}px`
    }, p = r ? "disabled" : "primary", h = r ? "disabled" : "default-gray", A = r ? "outline" : "gray", C = m ? "up" : "down", u = T ? "bold" : "normal", F = R(
      t["filter-tagged-button-root"],
      [t[`size-${$}`]],
      {
        [t.disabled]: r,
        [t.isReadOnly]: f
      }
    ), G = () => {
      x(!v), i == null || i();
    }, I = c || d, L = I ? `${I - 2 * j - 2 * H - 2 * l + g}px` : "auto";
    return /* @__PURE__ */ s(
      "button",
      {
        style: y,
        className: F,
        disabled: r,
        onClick: G,
        "data-testid": _,
        "aria-label": W(o, a),
        ref: E,
        ...D,
        children: [
          /* @__PURE__ */ s("span", { className: t["labels-icon"], children: [
            n && B(n, {
              outline: h,
              color: A
            }),
            /* @__PURE__ */ s(
              "span",
              {
                className: t.labels,
                style: {
                  maxWidth: L
                },
                children: [
                  /* @__PURE__ */ e(N, { color: p, children: o }),
                  /* @__PURE__ */ e(N, { variant: "semi-bold", color: p, isEllipsis: !0, children: a }),
                  O && /* @__PURE__ */ e(
                    "span",
                    {
                      className: t.notificationIndicator,
                      "data-testid": `${b}-notification-indicator`,
                      "aria-label": "notification-dot",
                      children: /* @__PURE__ */ e(P, { count: 1, variant: "dot" })
                    }
                  )
                ]
              }
            )
          ] }),
          !f && /* @__PURE__ */ e("span", { className: t.chevron, children: /* @__PURE__ */ e(
            S,
            {
              outline: h,
              direction: C,
              type: u,
              "data-testid": `${u}-chevron`
            }
          ) })
        ]
      }
    );
  }
);
export {
  b as FILTER_TAGGED_BUTTON_DEFAULT_TESTID,
  X as FilterTaggedButton
};
//# sourceMappingURL=index.es14.js.map
